import {NgModule} from '@angular/core';

import {ImageEditorComponent} from "./image-editor.component";
import {ButtonModule} from 'primeng/primeng';

@NgModule({
	imports: [
	  ButtonModule
	],
    declarations: [
      ImageEditorComponent
    ],
    exports: [
        ImageEditorComponent
    ]
})
export class ImageEditorModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/image-editor/image-editor.module.ts